import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from '~constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { constructUrlWithParams } from '../helpers'

export interface GetWelcomePopupRes {
  isEnabled: boolean
  isInternal: boolean
  releaseDate: Date
  version: number
  title: string
  description: string
  fileId?: string
  updatedAt: Date
  updatedBy: string
  _id: string
  visibleForEmailDomains: VisibleForEmailDomains[]
}

const emailDomainsOptions = [
  'Internal users (@maersktankers.com)',
  'External users (other email domains)',
]

export type VisibleForEmailDomains = (typeof emailDomainsOptions)[number]

export function useGetWelcomePopup({
  params = {},
}: {
  params?: { forEdit?: boolean }
} = {}) {
  const fetchRequest = useFetch<GetWelcomePopupRes[]>()

  const url = constructUrlWithParams(`${apiBase()}/welcome-popup`, params)

  return useQuery({
    queryKey: [url],
    queryFn: async () => fetchRequest(url),
    staleTime: tenMinutes,
  })
}
